<div class="row" *ngIf="isLoadingSearch === false && data?.length > 0" >
    <div class="col-12">
        <div class="mgn-bottom-40 swiper-container swiper-nav-bullets swiper-featured-institutions">

            <swiper [config]="swiperConfig" class="equal-height-group">

                <ng-template swiperSlide class="swiper-slide" *ngFor="let e of data">
                    <div class="institution-card" [ngStyle]="{'background-image': 'url(&quot;' + e?.employerMainImage + '&quot;)'}">
                        <div class="row">
                            <div class="col-12 col-sm-auto text-center text-sm-left">
                                <div class="wrap-institution-img">
                                    <img class="institution-img" loading="lazy" alt="logotipo de la institución"
                                        src="{{e?.employerLogo}}" />
                                </div>
                            </div>
                            <div class="align-items-sm-end col-12 col-sm d-sm-flex text-center text-sm-left">
                                <h4 class="institution-name">{{e.employerName}}</h4>
                                <h4 class="institution-name"></h4>
                            </div>
                        </div>
                        <div class="info-area">
                            <div class="row">
                                <div class="col-12">
                                    <ul class="list-unstyled info-list font-weight-normal"  >
                                        <li class="clamp-1-text">
                                            <div class="wrap-ico">
                                                <i class="pj-ico pj-ico-geo2"></i>
                                            </div> {{e.employerAddress3}}, {{e.employerAddress1}}
                                        </li>
                                        <li>
                                            <div class="wrap-ico"><i class="pj-ico pj-ico-institucion"></i>
                                            </div> {{e.employerType}}
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-12">
                                    <div class="wrap-btns">

                                        <a *ngIf="e.employerJobsOpenQty > 0" class="btn btn-block-xs btn-light btn-sm"
                                            [routerLink]="'/institucion/perfil/' + e.employerProfileUrl"
                                            [queryParams]="{op: 'anuncios'}" target="_blank"
                                            title="Ver ofertas laborales de esta institución">Ver ofertas</a>

                                        <a *ngIf="e?.employerJobsOpenQty === 0 && e?._idInstitution > 0"
                                            class="btn btn-block-xs btn-light btn-sm" role="button"
                                            title="Enviar currículum vitae" (click)="onClickSendResume($event, e?._idInstitution)">Enviar
                                            CV</a>

                                        <a class="btn btn-block-xs btn-link btn-sm white-link"
                                            [routerLink]="'/institucion/perfil/' + e.employerProfileUrl" target="_blank">Conocer
                                            institución</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template swiperSlide class="swiper-slide">
                    <div class="explore-institutions">
                        <div class="row">
                            <div class="align-items-center col-12 d-flex justify-content-center">
                                <div class="text-center">
                                    <p>Tenemos muchísimas instituciones más que te podrían interesar.</p>
                                    <a class="btn btn-block-xs btn-primary btn-sm" [routerLink]="'/'+[constantsService.BASE_PATH_INSTITUTION_SEARCH]" role="button">Explorar
                                        ahora</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

            </swiper>

            <div id="swiper-home-institution-pro" class="swiper-pagination"></div>

            <div class="controls-swiper-wrapper-2">
                <div id="swiper-home-institution-pro-prev" class="swiper-button-prev swiper-card-prev"></div>
                <div id="swiper-home-institution-pro-next" class="swiper-button-next swiper-card-next"></div>
            </div>
        </div>
    </div>
</div>